import { FC } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { PayoutsTable } from "../tables/finance/PayoutsTable";
import { CreditTable } from "../tables/finance/CreditTable";
import { FinanceSummaryTable } from "../tables/finance/FinanceSummaryTable";
import { ReportToolbar } from "../reports/ReportToolbar";
import { useReportFilters } from "../reports/useReportFilters";

// Финансы: «Выручка», «Расходы», «Прибыль» — сводка по дням за период,
// «Нам должны» и «Мы должны» — списки компаний с поиском
export const FinancePage: FC = () => {
  const location = useLocation();
  const filters = useReportFilters();

  const isCompanyReport =
    location.pathname.endsWith("/credit") ||
    location.pathname.endsWith("/payouts");

  return (
    <>
      <div className="px-[5px]">
        {isCompanyReport ? (
          <ReportToolbar
            search={filters.search}
            onSearchChange={filters.setSearch}
            searchPlaceholder="Поиск по названию, ИНН, ФИО руководителя"
          />
        ) : (
          <ReportToolbar
            period={filters.period}
            onPeriodChange={filters.selectPeriod}
            onDateFromChange={filters.handleDateFromChange}
            onDateToChange={filters.handleDateToChange}
          />
        )}
      </div>
      <div className="px-[5px]">
        <Routes>
          <Route path="/credit" element={<CreditTable query={filters.search} />} />
          <Route
            path="/payouts"
            element={<PayoutsTable query={filters.search} />}
          />
          <Route
            path="/expenses"
            element={
              <FinanceSummaryTable
                metric="expenses"
                dateFrom={filters.dateFrom}
                dateTo={filters.dateTo}
              />
            }
          />
          <Route
            path="/profit"
            element={
              <FinanceSummaryTable
                metric="profit"
                dateFrom={filters.dateFrom}
                dateTo={filters.dateTo}
              />
            }
          />
          <Route
            path="/*"
            element={
              <FinanceSummaryTable
                metric="revenue"
                dateFrom={filters.dateFrom}
                dateTo={filters.dateTo}
              />
            }
          />
        </Routes>
      </div>
    </>
  );
};
